import MessageDetail from '@/views/MessageDetail/index.vue'

const MessageDetailRouter = {
  path: '/message-detail',
  name: 'MessageDetail',
  component: MessageDetail,
  props: (route) => ({
    secret: route.query.secret,
    msgId: route.query.msgId
  })
}

export default MessageDetailRouter
